import CreateBulkEntities from '../CreateBulkEntities'

const CreateBulkLovs = ({ jobType }) => {
  return <CreateBulkEntities type={jobType} />
}
export default CreateBulkLovs
